import { getDateDayMonth, isDateInPast } from "@/lib/date";

export type CourseEnrollMessageKey =
  | "futureDatesToBeAnnounced"
  | "viewCourseMaterials"
  | "enrolledGoToCourse"
  | "enrollAfter"
  | "enroll"
  | "advanceYourCareer";

export type CourseEnrollMessageResult = {
  key: CourseEnrollMessageKey;
  values?: Record<string, string | number>;
};

const getCourseRunEnrollButtonText = (
  {
    enrollmentStart,
    enrollmentEnd,
    end,
  }: {
    enrollmentStart: Date | null;
    enrollmentEnd: Date | null;
    end: Date | null;
  },
  userEnrolled: boolean,
): CourseEnrollMessageResult => {
  const enrollmentEnded = enrollmentEnd ? isDateInPast(enrollmentEnd) : false;
  const courseRunEnded = end ? isDateInPast(end) : false;
  const enrollmentStarted = !enrollmentStart || isDateInPast(enrollmentStart);

  if (!userEnrolled && enrollmentEnded) {
    return { key: "futureDatesToBeAnnounced" };
  }

  if (courseRunEnded || enrollmentEnded) {
    return { key: "viewCourseMaterials" };
  }

  if (userEnrolled) {
    return { key: "enrolledGoToCourse" };
  }

  if (!enrollmentStarted) {
    return {
      key: "enrollAfter",
      values: { date: getDateDayMonth(new Date(enrollmentStart)) },
    };
  }

  return { key: "enroll" };
};

export const getEnrollButtonText = (
  {
    enrollmentStart,
    enrollmentEnd,
    end,
  }: {
    enrollmentStart: Date | null;
    enrollmentEnd: Date | null;
    end: Date | null;
  },
  userEnrolled: boolean,
): CourseEnrollMessageResult => {
  const enrollmentEnded = enrollmentEnd ? isDateInPast(enrollmentEnd) : false;
  const courseRunEnded = end ? isDateInPast(end) : false;
  const enrollmentStarted = !enrollmentStart || isDateInPast(enrollmentStart);

  if (courseRunEnded || enrollmentEnded) {
    return { key: "viewCourseMaterials" };
  }

  if (userEnrolled) {
    return { key: "enrolledGoToCourse" };
  }

  if (!enrollmentStarted) {
    return {
      key: "enrollAfter",
      values: { date: getDateDayMonth(new Date(enrollmentStart)) },
    };
  }

  return { key: "advanceYourCareer" };
};

export default getCourseRunEnrollButtonText;
